import { observer } from 'mobx-react-lite';
import type { JSX, ReactNode } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { CardV2 as Card, Skeleton } from '@feathr/components';
import { useFundraiser } from '@feathr/extender/hooks';
import projectAllocationIcon from '@feathr/extender/images/project_allocation_icon.svg';
import { useStore } from '@feathr/extender/state';
import { cssVar } from '@feathr/hooks';

import TipAssignmentModal from './TipAssignmentModal';

import * as styles from './TipAssignmentCard.css';

function TipAssignmentCard(): JSX.Element {
  const { t } = useTranslation();
  const { Events } = useStore();
  const { fundraiser, isPending: isFundraiserPending } = useFundraiser();
  const hasProject = !!fundraiser?.mediaCreditEvent;
  const event = hasProject ? Events.get(fundraiser.mediaCreditEvent) : undefined;
  const isEventPending = hasProject && (!!event ? event.isPending : true);
  const isCardPending = isFundraiserPending || isEventPending;

  function getDescriptionNode(): ReactNode {
    if (isCardPending) {
      return <Skeleton width={cssVar('--content-max-width-v2')} />;
    }
    if (!hasProject) {
      return t('Select which project growth credits are added to');
    }
    return t('Growth credits assigned to: {{- name}}', {
      name: event?.name ?? '',
    });
  }

  const descriptionNode = getDescriptionNode();

  return (
    <div>
      <Card width={'full'}>
        <Card.Header
          description={descriptionNode}
          prefix={
            <img
              alt={'Folder icon with a dark grey outline on a light gray background.'}
              className={styles.icon}
              src={projectAllocationIcon}
            />
          }
          title={t('Growth Credit Assignment')}
        >
          <TipAssignmentModal isLoading={isCardPending} />
        </Card.Header>
      </Card>
    </div>
  );
}

export default observer(TipAssignmentCard);
